import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { cloneData, getTextcolor, isArray } from 'src/app/helper/class/utilityHelper';
import { formBuilderData } from 'src/app/helper/interface/response';

@Component({
  selector: 'dental-chart-ref',
  templateUrl: './dental-chart-ref.component.html',
  styleUrl: './dental-chart-ref.component.scss'
})
export class DentalChartRefComponent implements OnInit {
  @Output() selectionChange = new EventEmitter<void>();
  allTeethNumber = [];
  // teethGroupType = ["UPR", "LOR", "LOL", "UPL", "UPLCH", "UPRCH", "LOLCH", "LORCH"];
  teethGroupType = [
    'UPR',
    'UPL',
    'LOR',
    'LOL',
    'UPLCH',
    'UPRCH',
    'LOLCH',
    'LORCH'
  ];
  specialTeeth: any = ['A', 'B', 'C', 'D', 'E'];
  teethGroup: any = {};
  remarksControl = new FormControl('');
  chartData: any;
  mouseOverTeethData: any
  _bsModalRef: BsModalRef = {} as BsModalRef;
  public onClose: Subject<boolean> = new Subject();
  @Input() showPrimary = false;
  showAddBtn: boolean = false
  @Input() showRemarks = false;
  @Input() remarksTitle = 'Remarks';
  basicFormData: formBuilderData[] = [];
  selected: any[] = [];
  pendingSelectedTeeth: any[] = [];
  constructor(private injector: Injector) { }
  ngOnInit(): void {
    this.genTeethCode();
    this.setSelectedTeeth(this.pendingSelectedTeeth);
  }
  setInput(s: any) {
    this._bsModalRef = this.injector.get<BsModalRef>(BsModalRef);
    this.showAddBtn = true
    if (s.showRemarks) {
      this.showRemarks = true;
    }
    if (s.remarksTitle) {
      this.remarksTitle = s.remarksTitle;
    }
    if (s.formBuild && isArray(s.formBuild)) {
      this.basicFormData = s.formBuild
    }
    this.pendingSelectedTeeth = s.selectedTeeth || s.selectedTooth || s.tooth || [];
    this.setSelectedTeeth(this.pendingSelectedTeeth);
  }


  // genTeethCode() {
  //   // ['UPPER',"LOWER"]
  //   this.teethGroupType.forEach((a: any) => {
  //     const num_row = ['UPRCH', 'LOLCH', 'UPLCH', 'LORCH'].includes(a) ? 5 : 8,
  //       s = new Array(num_row).fill(0).map((n, index) => index + 1);
  //     this.teethGroup[a] = [];
  //     s.forEach((e: any, i) => {
  //       const th: any = { toothStatus: 'normal' };
  //       let num = 18, code = num, image_num = num;
  //       switch (a) {
  //         case 'UPR':
  //           num = 11 + i;
  //           code = num;
  //           image_num = num
  //           break;
  //         case 'UPL':
  //           num = 21 + i;
  //           code = num;
  //           image_num = num
  //           break;
  //         case 'LOR':
  //           num = 41 + i;
  //           code = num;
  //           image_num = num
  //           break;
  //         case 'LOL':
  //           num = 31 + i;
  //           code = num;
  //           image_num = num
  //           break;
  //         case 'UPLCH':
  //           num = 51 + i;
  //           // code = 5 + (cloneData(this.specialTeeth).reverse())[i];
  //           code = 5 + this.specialTeeth[i];
  //           image_num = num - 40
  //           break;
  //         case 'UPRCH':
  //           num = 61 + i;
  //           code = 6 + this.specialTeeth[i];
  //           image_num = num - 40
  //           break;
  //         case 'LOLCH':
  //           num = 81 + i;
  //           code = 8 + this.specialTeeth[i]
  //           // code = 8 + (cloneData(this.specialTeeth).reverse())[i]
  //           image_num = num - 40
  //           break;
  //         case 'LORCH':
  //           num = 71 + i;
  //           code = 7 + this.specialTeeth[i];
  //           image_num = num - 40
  //           break;
  //       }
  //       th.toothNumber = num
  //       th.imageNumber = image_num;
  //       th.toothCode = code;
  //       this.teethGroup[a].push(th);
  //     });
  //   })

  //   //  console.log('Denat alla ref ',this.teethGroup)
  // }


  genTeethCode() {

    const toothConfig = {
      UPR: [18, 17, 16, 15, 14, 13, 12, 11],
      UPL: [21, 22, 23, 24, 25, 26, 27, 28],

      LOR: [48, 47, 46, 45, 44, 43, 42, 41],
      LOL: [31, 32, 33, 34, 35, 36, 37, 38],

      UPLCH: [55, 54, 53, 52, 51],
      UPRCH: [61, 62, 63, 64, 65],

      LOLCH: [85, 84, 83, 82, 81],
      LORCH: [71, 72, 73, 74, 75]
    };

    this.teethGroup = {};

    Object.keys(toothConfig).forEach((group: string) => {

      this.teethGroup[group] = [];

      toothConfig[group].forEach((num: number) => {

        const tooth: any = {
          toothStatus: 'normal',
          toothNumber: num,
          toothCode: num,
          selected: false
        };

        // Primary teeth use same SVGs (11-15,21-25,31-35,41-45)
        if (num >= 51) {
          tooth.imageNumber = num - 40;
        } else {
          tooth.imageNumber = num;
        }

        this.teethGroup[group].push(tooth);
      });
    });
  }

  toggleShowPrimary() {
    this.showPrimary = !this.showPrimary
  }

  toggleTooth(tooth: any) {
    const index = this.selected.findIndex(t => t.toothNumber === tooth.toothNumber);

    if (index >= 0) {
      this.selected.splice(index, 1);
      tooth.selected = false;
    } else {
      this.selected.push(tooth);
      tooth.selected = true;
    }

    this.selectionChange.emit();
  }

  selectTeeth(num: number) {
    this.teethGroupType.forEach((a: any) => {
      this.teethGroup[a].map((e: any) => {
        if (num == e.toothNumber) {
          e.selected = !e.selected
        }
      });
    });
  }

  getSelected() {
    let result: any = [];
    this.teethGroupType.forEach((a: any) => {
      const s: any = this.teethGroup[a].filter(e => e.selected);
      result = [...result, ...s]
    });
    return result;
  }

  resetSelected() {
    this.teethGroupType.forEach((a: any) => {
      const s: any = this.teethGroup[a].map(e => e.selected = false);
    });
    this.selected = [];
  }

  setSelectedTeeth(teeth: any[] = []) {
    if (!teeth?.length || !Object.keys(this.teethGroup || {}).length) {
      return;
    }

    const selectedToothNumbers = teeth
      .map(tooth => typeof tooth === 'object' ? tooth?.toothNumber || tooth?.teeth_number : tooth)
      .filter(toothNumber => toothNumber !== undefined && toothNumber !== null && toothNumber !== '')
      .map(toothNumber => toothNumber.toString());

    this.selected = [];
    this.teethGroupType.forEach((group: any) => {
      this.teethGroup[group].forEach((tooth: any) => {
        tooth.selected = selectedToothNumbers.includes(tooth.toothNumber.toString());
        if (tooth.selected) {
          this.selected.push(tooth);
        }
      });
    });
  }

  setData(data: any) {
    if (data) {
      this.chartData = cloneData(data);
      Object.keys(this.chartData).forEach((a) => {
        const d = this.chartData[a];
        const color = Array.isArray(d) && d.length ? d?.[d.length - 1]?.['color_code'] || '' : '';
        this.teethGroupType.forEach((b) => {
          const i = this.teethGroup[b].findIndex((c) => c.toothNumber == a);
          if (![-1, null, undefined].includes(i)) this.teethGroup[b][i]['color_code'] = color;
        })
      })
    }
  }

  errorMsg = '';
  onAdd() {
    this.errorMsg = '';
    const selected: any = { tooth: this.getSelected() };
    if (selected.tooth.length == 0) {
      this.errorMsg = 'Select any tooth';
      return
    }
    selected.remarks = this.remarksControl.value || '';
    this._bsModalRef.hide();
    this.onClose.next(selected);
  }


  getTextcolor(color) {
    return getTextcolor(color || '#fff');
  }


}
